import styled from 'styled-components';

import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

export const Container = styled(View)`
  flex-direction: row;
  align-items: center;
`;

export const Name = styled(Text).attrs({
  weight: 'semibold',
})``;
